import "./App.css";
import React, { useState } from "react";
import { Layout, Menu, Select, Typography } from "antd";
import Transactions from "./components/Transactions";
import Stats from "./components/Stats";
import { BrowserRouter, Routes, Route, NavLink } from "react-router-dom";

const { Header, Content, Footer, Sider } = Layout;
const { Title } = Typography;

const navItems = [
  { key: 1, label: <NavLink to="/">Transactions</NavLink> },
  { key: 2, label: <NavLink to="/stats">Stats</NavLink> },
];

const options = [
  "All Months", "January", "February", "March", "April",
  "May", "June", "July", "August", "September", 
  "October", "November", "December"
];

const App = () => {
  const [month, setMonth] = useState(3);

  return (
    <BrowserRouter>
      <Layout style={{ minHeight: "100vh" }}>
        <Sider theme="light" breakpoint="lg" collapsedWidth="0">
          <div className="logo" style={{ padding: "20px", textAlign: "center" }}>
            <Title level={3} style={{ color: "black", marginBottom: 0 }}>Dashboard</Title>
          </div>
          <Menu theme="light" mode="inline" defaultSelectedKeys={["1"]} items={navItems} />
        </Sider>

        <Layout>
          <Header style={{ background: "#fff", padding: "0 20px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Title level={4} style={{ margin: 0 }}>Dashboard</Title>
            <Select
              size="large"
              value={month}
              onChange={setMonth}
              style={{ width: 200 }}
              options={options.map((text, i) => ({ value: i, label: text }))}
            />
          </Header>

          <Content style={{ margin: "24px 16px", padding: "24px", background: "#fff", borderRadius: "8px", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)" }}>
            <Routes>
              <Route path="/" element={<Transactions month={month} monthText={options[month]} />} />
              <Route path="/stats" element={<Stats month={month} monthText={options[month]} />} />
            </Routes>
          </Content>

          <Footer style={{ textAlign: "center", background: "#f0f2f5" }}>
            Created by <strong>Krish Jaiswal</strong> | © 2024
          </Footer>
        </Layout>
      </Layout>
    </BrowserRouter>
  );
};

export default App;
